import {AggPolicyStatus} from 'modules/decisionsNext/api/types';

import {createEnumMap} from 'utils/createEnumMap';

export const policyStatusLabelsMap: Record<AggPolicyStatus, string> = createEnumMap(
  {
    [AggPolicyStatus.NewNew]: 'Net-New',
    [AggPolicyStatus.NewTotal]: 'New-Total',
    [AggPolicyStatus.NewCrossSell]: 'Cross Sell',
    [AggPolicyStatus.RenewalRenewal]: 'Renewals-Renewed',
    [AggPolicyStatus.RenewalRewrite]: 'Renewals-Rewritten',
    [AggPolicyStatus.RenewalTotal]: 'Renewals-Total',
    [AggPolicyStatus.LostLost]: 'Lost',
    [AggPolicyStatus.LostTotal]: 'Lost-Total',
    [AggPolicyStatus.LostCancelled]: 'Cancelled',
    [AggPolicyStatus.LostNonRenewable]: 'Non-Renewable',
    [AggPolicyStatus.ClientLost]: 'Lost',
    [AggPolicyStatus.Other]: 'Other',
  },
  AggPolicyStatus,
  ''
);

export const amsPolicyStatuses = [
  AggPolicyStatus.NewTotal,
  AggPolicyStatus.RenewalTotal,
  AggPolicyStatus.LostTotal,
  AggPolicyStatus.Other,
];

export const nonAmsPolicyStatuses = [
  AggPolicyStatus.NewNew,
  AggPolicyStatus.RenewalTotal,
  AggPolicyStatus.NewCrossSell,
];

export const extendedNonAmsPolicyStatuses = [
  AggPolicyStatus.NewNew,
  AggPolicyStatus.NewCrossSell,
  AggPolicyStatus.RenewalRenewal,
  AggPolicyStatus.RenewalRewrite,
];

export const lostPolicyStatuses = [AggPolicyStatus.LostLost, AggPolicyStatus.LostCancelled];
